<template>
  <b-modal
    v-model="modalData.enabled"
    id="bv-modal-tabela"
    size="xl"
    hide-footer
    centered
    scrollable
    :title="modalData.title"
  >
    <div class="bv-modal-body">
      <div class="caption-map">
        <div class="caption-item">
          <span class="c-yellow"></span>
          <span>Cadastro SISAB &lt; Parâmetro</span>
        </div>
        <div class="caption-item">
          <span class="c-green"></span>
          <span>Cadastro SISAB &gt; Máximo</span>
        </div>
        <div class="caption-item">
          <span class="c-red"></span>
          <span>Cadastro SISAB &gt; Máximo</span>
        </div>
        <div class="caption-item">
          <span class="caption-item c-orange"></span>
          <span>Cadastros em não eSF ou eAP</span>
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th rowspan="2">Porte Populacional (habitantes)</th>
            <th colspan="2">eSF</th>
            <th colspan="2">eAP 30h</th>
            <th colspan="2">eAP 20h</th>
          </tr>
          <tr>
            <th>Parâmetro de<br />pessoas<br />vinculadas</th>
            <th>Limite máximo</th>
            <th>Parâmetro de<br />pessoas<br />vinculadas</th>
            <th>Limite máximo</th>
            <th>Parâmetro de<br />pessoas<br />vinculadas</th>
            <th>Limite máximo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <td>{{ item.porte }}</td>
            <td>{{ item.eSF.parametro }}</td>
            <td>{{ item.eSF.limite }}</td>
            <td>{{ item.eAP30h.parametro }}</td>
            <td>{{ item.eAP30h.limite }}</td>
            <td>{{ item.eAP20h.parametro }}</td>
            <td>{{ item.eAP20h.limite }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalTabela',
  props: {
    modalData: {
      type: Object,
      required: true,
      default: () => ({
        enabled: false,
        title: 'Informações',
      }),
    },
    tableData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.caption-map {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 15px;
}

.caption-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  span:first-child {
    width: 15px;
    height: 15px;
    border-radius: 30px;
    @media screen and (max-width: 656px) {
      width: 35px;
    }
  }
  h4 {
    font-size: 16px;
    margin: 0;
  }
  .c-green {
    background-color: green;
  }

  .c-orange {
    background-color: orange;
  }

  .c-red {
    background-color: red;
  }
  .c-yellow {
    background-color: yellow;
  }
}

.bv-modal-body {
  overflow: auto;
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;

    th,
    td {
      padding: 8px;
      border: 1px solid #ddd;
      text-align: left;
      max-width: 200px;
      word-wrap: break-word;
    }

    th {
      background-color: #f2f2f2;
    }
  }
}
</style>
